module.exports = __webpack_public_path__ + "img/106.10100208.png";